module.exports = "/_next/static/images/mn-5c65c3f3229ab257f935abe4c1597ad0.svg";